module.exports = __webpack_public_path__ + "img/back-btn-bg.b55d0b66.png";